import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
} from '@angular/core';
import {
  ApplicationState,
  getProductsTechnicalError,
  getSelectedProductAvailableSubscriptions,
  getSelectedProductDetails,
  getUserProduct,
} from '../../../../store/reducers';
import { Store } from '@ngrx/store';
import { OnDestroyHookDirective } from '../../../../shared/hooks';
import { combineLatest } from 'rxjs';
import {
  Characteristic,
  isPrepaid,
  isRes,
  MobileProduct,
  Option,
  OptionStatus,
  PlcCodes,
  Subscription,
} from '@dch/products-business-logic';
import { ActivatedRoute, Router } from '@angular/router';
import {
  CustomerService,
  InceptionService,
  LanguageService,
  TranslationService,
} from '@proximus/ng-common';
import { isEmpty } from 'lodash';
import { GetOptionGroupsConfig } from '../../../../store/actions/magnolia-config.actions';
import { WebshopUtils } from '../../../../shared/webshop/webshop-utils';
import { Alert, AlertsService } from '@proximus/ng-common-components';
import { GetProductDetails } from '../../../../store/actions/product-details.actions';
import { getPiiServiceId, savePii } from '../../../../shared/pii/pii.utils';
import { buildTaggingProduct } from '../../../../tagging/tagging.utils';
import { getDescriptionMessage } from '../../../../shared/order-utils/order-utils';
import * as ProductsActions from '../../../../store/actions/products.actions';
import { CpvService } from '../../../../services/cpv.service';

interface AssociativeArray {
  [key: string]: string;
}

declare let jQuery: any;

@Component({
  selector: 'mprd-priceplan-details',
  templateUrl: './priceplan-details.component.html',
})
export class PriceplanDetailsComponent
  extends OnDestroyHookDirective
  implements OnInit
{
  public availableSubscriptions: Subscription[];
  public activeSubscription: Subscription;
  private segment = '';
  public activeFavApp: Option;
  public hasError: boolean;
  public fullControl: boolean;
  public selectedProduct: MobileProduct;
  public displayPendingOrderAlert = false;
  public orderButtonsDisabled = false;
  public selectedPricePlan;
  public fetching: boolean;
  public hasFullControl: boolean;
  public isSpecificConditionsExpanded = false;
  public isBelfiusPartner = false;
  public packMpcUuid: string;

  public tokenEndPhoneNumber: string;
  public tokenMpcUuid: string;
  public promoCode: string;

  public isUnavailableSubscriptionFlexPackLink = false;

  // tagging
  public jsonProduct: string;
  public modalId: string;

  public modalIdArray: AssociativeArray[] = [];
  public fivegArray: AssociativeArray[] = [];
  public fivegAlreadyCalculated = false;
  public pendingFivegCalculation = false;
  private isModalIdLoaded = false;

  @ViewChild('modalPricePlan') modalPricePlan: any;
  private magnoliaTranslationBaseKey = 'mobile-swap.priceplan.more-info-modal.';

  constructor(
    private store: Store<ApplicationState>,
    private translationService: TranslationService,
    private customerAccount: CustomerService,
    private inceptionService: InceptionService,
    private elementRef: ElementRef,
    private ref: ChangeDetectorRef,
    private alertService: AlertsService,
    private languageService: LanguageService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private cpvService: CpvService,
  ) {
    super();
  }

  ngOnInit() {
    this.fetching = true;
    this.addSubscription(
      this.store.select(getProductsTechnicalError).subscribe((value) => {
        this.hasError = value !== null;
      }),
    );

    if (this.isADeeplink()) {
      //getting the required params
      this.addSubscription(
        this.activatedRoute.params.subscribe((params) => {
          // here we are in the deeplink case => treating the data
          if (!!params && params['token']) {
            const token = params['token'];
            if (token.indexOf('-') > -1) {
              [this.tokenEndPhoneNumber, this.tokenMpcUuid] = token.split('-');
            } else {
              this.tokenMpcUuid = token;
            }
          }
        }),
      );

      // if any missing info in the deeplinkCode
      if (!this.hasCorrectToken()) {
        this.routeToOverview();
      }

      //getting the query params
      this.addSubscription(
        this.activatedRoute.queryParams.subscribe((params: any) => {
          this.promoCode = params['promoCode'];
        }),
      );

      //getting the user products
      this.getProducts();

      this.addSubscription(
        this.store.select(getUserProduct).subscribe((userProduct) => {
          if (
            userProduct &&
            ((userProduct.packs && userProduct.packs.length > 0) ||
              (userProduct.outOfPacks && userProduct.outOfPacks.length > 0))
          ) {
            const productsAvailableForDeepLink = this.filterMobilesProducts(
              userProduct.packs,
              userProduct.outOfPacks,
              this.tokenEndPhoneNumber,
            );

            if (
              !productsAvailableForDeepLink ||
              productsAvailableForDeepLink.length !== 1
            ) {
              this.routeToOverview();
            } else {
              this.loadSelectedPricePlanDetails(
                productsAvailableForDeepLink[0].accessNumber,
              );
            }
          }
        }),
      );
    } else {
      this.loadPricePlanDetails();
    }
  }

  private loadSelectedPricePlanDetails(accessNumber: string) {
    savePii(accessNumber);
    this.loadPricePlanDetails();
  }

  private loadPricePlanDetails() {
    const appBrand = this.translationService.getTranslatedValueFor('app.brand');

    this.store.dispatch(new GetOptionGroupsConfig());
    this.store.dispatch(
      new GetProductDetails({
        productType: 'mobile',
        serviceId: getPiiServiceId(),
      }),
    );

    this.addSubscription(
      combineLatest([
        this.store.select(getSelectedProductDetails),
        this.customerAccount.getCustomerAccount(),
        this.store.select(getSelectedProductAvailableSubscriptions),
      ]).subscribe(
        ([product, customer, availableSubscriptionsWithFlexFlag]) => {
          const availableSubscriptions =
            availableSubscriptionsWithFlexFlag.availableSubscriptions;
          if (
            product &&
            product.mobileProductDetails &&
            JSON.stringify(this.selectedProduct) !==
              JSON.stringify(product.mobileProductDetails) &&
            (!this.selectedProduct ||
              JSON.stringify(this.selectedProduct.availableSubscriptions) !==
                JSON.stringify(
                  product.mobileProductDetails.availableSubscriptions,
                ))
          ) {
            this.isUnavailableSubscriptionFlexPackLink =
              availableSubscriptionsWithFlexFlag.isUnavailableSubscriptionFlexPackLink;
            this.selectedProduct = product.mobileProductDetails;
            this.jsonProduct = buildTaggingProduct(this.selectedProduct);
            this.activeSubscription =
              product.mobileProductDetails.activeSubscription;
            this.segment =
              customer.getSelectedCustomer().subsegment === 'BUS'
                ? 'SE'
                : 'RES';

            this.activeSubscription.computeCharacteristics = this.transform(
              this.activeSubscription,
            );
            this.activeFavApp = product.mobileProductDetails.options.find(
              (value) =>
                value.optionGroup === 'FAVAPP' &&
                value.ibStatus === OptionStatus.ACTIVE,
            );
            if (!this.activeFavApp) {
              this.activeFavApp = product.mobileProductDetails.options.find(
                (value) =>
                  value.optionGroup === 'FAVAPP' &&
                  value.optionCodeForDescription === 'DXDVF', // Whats'app is selected by default
              );
            }

            this.isBelfiusPartner = this.selectedProduct.isBelfiusPartner;
            this.packMpcUuid = this.selectedProduct.packMpcUuid;

            WebshopUtils.publishCartRetrival(
              this.selectedProduct.installationId,
              this.selectedProduct.accessNumber,
              this.selectedProduct.plc,
            );
          }

          if (availableSubscriptions) {
            let availableSubscriptionsTemp = availableSubscriptions;
            // MPRD-11449: Filter available subscriptions based on segment only for Proximus
            if (appBrand === 'proximus') {
              availableSubscriptionsTemp = Object.values(
                availableSubscriptions,
              ).filter((s) => s.segment === this.segment);
            }
            availableSubscriptionsTemp.forEach((subscription) => {
              subscription.computeCharacteristics =
                this.transform(subscription);
            });
            availableSubscriptionsTemp = this.sortByFamilyAndPrice(
              availableSubscriptionsTemp,
            );

            this.hasFullControl =
              availableSubscriptionsTemp.filter(
                (v: Subscription) => v.family === 'Full Control',
              ).length > 0;

            //MPRD-9069: Assign value to this.availableSubscriptions only if value has changed to avoid duplicate tagging.
            if (
              JSON.stringify(availableSubscriptionsTemp) !==
              JSON.stringify(this.availableSubscriptions)
            ) {
              this.availableSubscriptions = availableSubscriptionsTemp;
            }
          }
          setTimeout(() => {
            this.inceptionService.rsTooltip(this.elementRef);
            // scroll to recommended plan if any
            if (this.tokenMpcUuid) {
              this.inceptionService.scrollToElement(
                '.rs-sbox-highlighted-txt-container',
                100,
              );
            }
          });
          this.checkFiveGOption();
          this.preselectOption(this.tokenMpcUuid);
          this.generateModalContentArray();
          this.fetching = false;
        },
      ),
    );
  }

  private getProducts() {
    this.store.dispatch(new ProductsActions.GetProducts());
  }

  private preselectOption(tokenMpcUuid: string) {
    if (tokenMpcUuid) {
      const index = this.availableSubscriptions?.findIndex(
        (item) => item.mpcUuid === tokenMpcUuid,
      );
      if (index != -1) {
        this.updateSelectedRadio(index);
      } else {
        this.routeToOverview();
      }
    }
  }

  public toggleFullControl() {
    this.fullControl = !this.fullControl;
    this.selectedPricePlan = undefined;
  }

  public updateSelectedRadio(pricePlanIndex) {
    this.selectedPricePlan = pricePlanIndex;
  }

  public isPlanSelected(pricePlanIndex) {
    return this.selectedPricePlan === pricePlanIndex;
  }

  public isRecommendedPlan(productPlanId) {
    return this.tokenMpcUuid === productPlanId;
  }

  public toggleSpecificConditionsExpanded() {
    this.isSpecificConditionsExpanded = !this.isSpecificConditionsExpanded;
  }

  public isSECustomer() {
    return this.segment === 'SE';
  }

  public onResult(event) {
    if (event?.action && event?.action === 'aiaPending') {
      this.displayPendingOrderAlert = true;
      this.inceptionService.scrollToElement('body', 500);
    } else if (event && event.orderingInProgress) {
      this.orderButtonsDisabled = true;
    } else if (event && event.type && event.type === 'success') {
      if (event.action && event.action === 'add') {
        this.dispatchAlert(
          event.type,
          event.mpcUuid,
          this.translationService.getTranslatedValueFor(
            'message.confirmation.title',
          ),
          this.translationService.getTranslatedValueFor(
            'message.confirmation.description',
          ),
        );
        this.selectedPricePlan = undefined;
        this.orderButtonsDisabled = true;
      }
    } else if (event && event.type && event.type === 'error') {
      if (event.suspended) {
        this.dispatchAlert(
          event.type,
          event.mpcUuid,
          this.translationService.getTranslatedValueFor('message.error.title'),
          this.translationService.getTranslatedValueFor(
            'message.error.description.frozenAssets',
          ),
        );
        this.orderButtonsDisabled = false;
      } else if (event.action && event.action === 'add') {
        this.dispatchAlert(
          event.type,
          event.mpcUuid,
          this.translationService.getTranslatedValueFor('message.error.title'),
          getDescriptionMessage(event, this.translationService),
        );
        this.orderButtonsDisabled = false;
      }
    }
  }

  private transform(plan: Subscription) {
    if (plan && plan.characteristics?.length > 0) {
      const characteristics = plan.characteristics;
      const calls = this.transformCharacteristic(characteristics, 'CALLS');
      const data = this.transformCharacteristic(characteristics, 'DATA_MOBILE');
      const sms = this.transformCharacteristic(characteristics, 'SMS');
      const favapp = this.transformCharacteristic(
        characteristics,
        'FAV_APP_FLAVOUR',
      );
      return {
        calls: calls.value,
        sms: sms.value,
        data: data.value,
        allUnlimited: calls.unlimited && data.unlimited && sms.unlimited,
        favapp,
      };
    }
  }

  private transformCharacteristic(
    characteristics: Characteristic[],
    type: any,
  ): any {
    const characteristic = characteristics.find((c) => c.type === type);
    switch (type) {
      case 'CALLS':
        return {
          value:
            characteristic?.value === 'unl_calls'
              ? this.translationService.getTranslatedValueFor(
                  'mobile.priceplan.unlcalls',
                )
              : characteristic.value +
                ' ' +
                this.translationService.getTranslatedValueFor(
                  'mobile.priceplan.minutes',
                ),
          unlimited: characteristic.value === 'unl_calls',
        };
      case 'DATA_MOBILE':
        return {
          value:
            characteristic?.value === 'unl_mob_data'
              ? this.translationService.getTranslatedValueFor(
                  'mobile.priceplan.unldata',
                )
              : characteristic.value +
                ' ' +
                (characteristic.unit === 'gb'
                  ? this.translationService.getTranslatedValueFor(
                      'mobile.priceplan.gb',
                    )
                  : this.translationService.getTranslatedValueFor(
                      'mobile.priceplan.mb',
                    )),
          unlimited: characteristic.value === 'unl_mob_data',
        };
      case 'SMS':
        return {
          value:
            characteristic?.value === 'unl_sms'
              ? this.translationService.getTranslatedValueFor(
                  'mobile.priceplan.unlsms',
                )
              : characteristic.value +
                ' ' +
                this.translationService.getTranslatedValueFor(
                  'mobile.priceplan.sms',
                ),
          unlimited: characteristic.value === 'unl_sms',
        };
      case 'FAV_APP_FLAVOUR':
        return characteristic?.value;
    }
  }

  public getPricePlanPrice(subscription: Subscription) {
    if (this.segment && subscription.price) {
      return isRes(this.segment) || isPrepaid(this.segment)
        ? subscription.price?.priceVat?.toString()
        : subscription.price?.priceNoVat?.toString();
    }
  }

  private sortByFamilyAndPrice(availableSubscriptionsTemp) {
    const sameFamilySubscriptions = availableSubscriptionsTemp
      .filter((value) => value.family === this.activeSubscription.family)
      .sort((a, b) => {
        if (a.price?.priceVat < b.price?.priceVat) {
          return -1;
        }
      });
    const subscriptionsByFamilyAndPrice = availableSubscriptionsTemp
      .filter((value) => value.family !== this.activeSubscription.family)
      .sort((a, b) => {
        if (a.price?.priceVat < b.price?.priceVat) {
          return -1;
        }
      })
      .sort((a, b) => {
        if (a.family < b.family) {
          return -1;
        }
      });
    sameFamilySubscriptions
      .reverse()
      .forEach((value) => subscriptionsByFamilyAndPrice.unshift(value));
    return subscriptionsByFamilyAndPrice;
  }

  private filterMobilesProducts(
    packs: any,
    outOfPacks: any,
    endPhoneNumber: string,
  ) {
    const listOfMobilePlcs = [
      PlcCodes.MI,
      PlcCodes.MV,
      PlcCodes.MMI,
      PlcCodes.MMV,
    ];

    const mobileProducts: Array<MobileProduct> = [];
    for (const pack of packs) {
      const coreProducts = pack?.coreProducts;
      const mobileProduct: Array<MobileProduct> = coreProducts.filter(
        endPhoneNumber
          ? this.filterPredicateWithPlcAndPhoneNumber(
              listOfMobilePlcs,
              endPhoneNumber,
            )
          : this.filterPredicateWithPlc(listOfMobilePlcs),
      );
      mobileProducts.push(...mobileProduct);
    }
    for (const outOfPack of outOfPacks) {
      const coreProducts = outOfPack?.coreProducts;
      const mobileProduct: Array<MobileProduct> = coreProducts.filter(
        endPhoneNumber
          ? this.filterPredicateWithPlcAndPhoneNumber(
              listOfMobilePlcs,
              endPhoneNumber,
            )
          : this.filterPredicateWithPlc(listOfMobilePlcs),
      );
      mobileProducts.push(...mobileProduct);
    }
    return mobileProducts;
  }

  private filterPredicateWithPlcAndPhoneNumber(
    listOfMobilePlcs: PlcCodes[],
    endPhoneNumber: string,
  ) {
    return (product) =>
      product &&
      listOfMobilePlcs.includes(product.plc) &&
      product.accessNumber?.endsWith(endPhoneNumber);
  }

  private filterPredicateWithPlc(listOfMobilePlcs: PlcCodes[]) {
    return (product) => product && listOfMobilePlcs.includes(product.plc);
  }

  private dispatchAlert(
    type: 'error' | 'info' | 'success' | 'warning',
    mpcuuid: string,
    title: string,
    description: string,
  ): void {
    const alert: Alert = {
      isClosable: true,
      alertKey: 'priceplandetailsalert',
      title,
      description,
      type,
      scrollTo: true,
      scrollOffset: 200,
    };
    this.alertService.dispatchAlert(alert);
  }

  private routeToOverview() {
    this.router.navigate(['/overview']);
  }

  private isADeeplink() {
    return this.router.url.includes('/deeplink');
  }

  private hasCorrectToken() {
    return !isEmpty(this.tokenMpcUuid);
  }

  private hasPromoCode() {
    return !isEmpty(this.promoCode);
  }

  openMoreInfoModal(pricePlanId: string) {
    const id = this.getModalId(pricePlanId);
    jQuery('#' + id).foundation('reveal', 'open');
  }

  getModalId(pricePlanId: string) {
    return this.translationService.getTranslatedValueFor(
      this.getInfoModalKey(pricePlanId),
    );
  }

  showMoreInfoCTA(pricePlanId: string) {
    const modalId = this.modalIdArray[pricePlanId];
    return modalId !== undefined && modalId !== '' && modalId !== ' ';
  }

  getInfoModalKey(pricePlanId: string) {
    return `${this.magnoliaTranslationBaseKey}${pricePlanId}`;
  }

  private generateModalContentArray() {
    if (
      !this.isModalIdLoaded &&
      this.availableSubscriptions &&
      this.availableSubscriptions.length > 0
    ) {
      for (const pricePlan of this.availableSubscriptions) {
        this.modalIdArray[pricePlan.mpcUuid] = this.getModalId(
          pricePlan.mpcUuid,
        );
      }
      this.isModalIdLoaded = true;
    }
  }

  checkFiveGOption() {
    if (!this.fivegAlreadyCalculated && !this.pendingFivegCalculation) {
      this.pendingFivegCalculation = true;
      const mpcUuids = this.availableSubscriptions?.map(
        (subscription) => subscription.mpcUuid,
      );
      this.cpvService
        .getProductsFiveg({ mpcUuids: mpcUuids })
        .subscribe((data) => {
          for (const mpcUuid of Object.keys(data.value)) {
            this.fivegArray[mpcUuid] = data.value[mpcUuid].fiveg == 'true'; // to cast it to a boolean
          }
          this.fivegAlreadyCalculated = true;
          this.pendingFivegCalculation = false;
        });
    }
  }
}
